import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import FinalistsPage from "@/pages/finalists/page";
import RankingPage from "@/pages/ranking/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/finalists",
    element: <FinalistsPage />,
  },
  {
    path: "/ranking",
    element: <RankingPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;